import { EnhancementReportStat } from "../../../models/enhancement/enhancement-report-stats"
import Top20Table from "./Top20Table"
import { Top20ByOnCallHoursTableData as Top20EmployeesTableData } from "./utils"
import { TableEmptyState } from "../TableEmptyState"

interface Top20EmployeesTableProps {
    data: EnhancementReportStat[]
    selectedRequestTypes?: string[] | null
}
  
function Top20ByCallOutHoursTable({ data, selectedRequestTypes }: Readonly<Top20EmployeesTableProps>) {
  // Only show data if no filter is selected or if "Call Out" is selected
  const shouldShowData = !selectedRequestTypes || selectedRequestTypes.length === 0 || selectedRequestTypes.includes('Call Out')
  
  // If filters are applied but "Call Out" is not selected, show specific message
  if (selectedRequestTypes && selectedRequestTypes.length > 0 && !selectedRequestTypes.includes('Call Out')) {
    return <TableEmptyState message="No data available - 'Call Out' not selected in filters" />
  }
  
  const filteredData = shouldShowData ? data : []
  const tableData = Top20EmployeesTableData(filteredData, 'Call Out')
  
  return (
    <Top20Table data={tableData} />
  )
}
  export default Top20ByCallOutHoursTable
